<template>
  <div class="ws-state-version">
    <v-row v-if="C_value">
      <v-col
        v-for="(field, fieldKey) in _updateFields"
        cols="12"
        :sm="field.sm ? field.sm : 12"
        :key="fieldKey"
        :style="{'display': $_displayCheck(field) ? 'initial' : 'none'}"
      >
        <WsState
          :type="field.type"
          :label="field.label"
          :fields="field.fields"
          :rules="field.rules"
          :autofocus="field.autofocus"
          :displayLabel="field.displayLabel"
          :maxlength="field.maxlength"
          :uploadUrl="field.uploadUrl"
          :modelName="field.modelName"
          :items="field.items"
          :displayCheck="field.displayCheck"
          :getRules="field.getRules"
          :originData="originData.last_version"
          :originDataEX="_originDataEX"
          :hasCloseChips="field.hasCloseChips"
          :originValue="$_getOriginValue(originValue,fieldKey)"
          :getText="field.getText"
          :orderWay="field.orderWay"
          :orderBy="field.orderBy"
          :conditionKeys="field.conditionKeys"
          :conditions="$_getConditions(fieldKey)"
          :defaultValue="field.defaultValue"
          :customParentData="customParentData"
          :value="C_value[fieldKey]"
          @input="$_onInput($event,fieldKey)"
          :requiredField="field.requiredField"
          :parentState="$_getParentState(fieldKey)"
          :parentStateName="field.parentStateName"
          :requiredFieldState="$_getParentState(fieldKey)"
          :errorMessage="$_getErrorMessage(fieldKey)"
          :rulesErrorMessage="field.rulesErrorMessage"
          :getItems="field.getItems"
          :getUrl="field.getUrl"
          :getParams="field.getParams"
          :getValue="field.getValue"
          :setValue="field.setValue"
          :placeholder="field.placeholder"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    C_value: null,
  }),
  methods: {
    $_getOriginValue(modelData, fieldKey) {
      if (!modelData) {
        return null;
      } else {
        return modelData[fieldKey];
      }
    },
    $_onInput($event, fieldKey) {
      if (this.fields[fieldKey].type == "act-picker") {
        for (let key in $event) {
          this.C_value[key] = $event[key];
        }
      }
      this.C_value[fieldKey] = $event;
    },
    $_valueInit() {
      const initValue = {};
      for (let fieldKey in this._updateFields) {
        const field = this.fields[fieldKey];
        if (field.readonly) {
          continue;
        }

        if (this.value && this.value[fieldKey] != undefined) {
          if (field.type == "belongsTo" && this.value) {
            initValue[fieldKey] = this.value[fieldKey].id;
          } else if (field.type == "hasMany" && this.value) {
            const _value = [];
            this.value[fieldKey].forEach((itemValueItem) => {
              _value.push(itemValueItem.id);
            });
            initValue[fieldKey] = _value;
          } else {
            initValue[fieldKey] = this.value[fieldKey];
          }
        } else if (field.defaultValue !== undefined) {
          initValue[fieldKey] = field.defaultValue;
        } else {
          initValue[fieldKey] = null;
        }
      }
      this.C_value = initValue;
    },
    $_getConditions(fieldKey) {
      if (fieldKey === "locales") return;
      const _conditions = [];
      const conditionKeys = this.$_getFieldAttr(fieldKey, "conditionKeys");
      if (!conditionKeys) {
        return [];
      }
      conditionKeys.forEach((conditionKey) => {
        let _value = "";
        if (this.value && this.value[conditionKey.fieldName]) {
          _value = this.value[conditionKey.fieldName];
        } else if (
          this.customParentData &&
          this.customParentData[conditionKey.fieldName]
        ) {
          _value = this.customParentData[conditionKey.fieldName];
        } else if (this.originData[conditionKey.fieldName]) {
          _value = this.originData[conditionKey.fieldName].id;
        } else {
          return;
        }
        _conditions.push({
          key: conditionKey.conditionName,
          value: _value,
          type: conditionKey.type,
        });
      });
      return _conditions;
    },
    $_getFieldAttr(fieldKey, keyName) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, this.fields);
      //看wsstaterelationshipselect檔案
      if (field) {
        return field[keyName];
      } else {
        return null;
      }
    },
    $_getParentState(fieldKey) {
      if (fieldKey == "locales" || !this.fields[fieldKey].requiredField) {
        return null;
      }
      if (
        this.customParentData &&
        this.customParentData[this.fields[fieldKey].requiredField]
      ) {
        return this.customParentData[this.fields[fieldKey].requiredField];
      } else if (this.originData[this.fields[fieldKey].requiredField]) {
        return this.originData[this.fields[fieldKey].requiredField];
      } else if (
        this.originData.last_version[
          this.fields[fieldKey].conditionKeys[0].fieldName
        ]
      ) {
        return this.originData.last_version[
          this.fields[fieldKey].conditionKeys[0].fieldName
        ];
      } else {
        return null;
      }
    },
    $_getErrorMessage(fieldKey) {
      if (this.fields[fieldKey].errorMessage) {
        return this.fields[fieldKey].errorMessage;
      } else {
        return null;
      }
    },
    $_displayCheck(field) {
      if (field.displayCheck) {
        if (field.displayCheck(this.originData.last_version)) {
          return true;
        } else {
          return field.displayCheck(this.originData.last_version);
        }
      } else {
        return true;
      }
    }
  },
  mounted() {
    this.$_valueInit();
  },
  computed: {
    _updateFields() {
      return this.$_CMS_geUpdateFields(this.fields);
    },
    _originDataEX() {
      if (!this.originDataEX) {
        return null;
      } else {
        return this.originDataEX.last_version;
      }
    },
  },
  props: {
    originValue: {},
    fields: {
      type: Object,
      default: null,
    },
    value: {},
    originData: {
      type: Object,
    },
    originDataEX: {
      type: Object,
    },
    customParentData: {
      type: Object,
    },
    hasCatchVersion: {
      type: Boolean,
      default: false,
    },
    getRules: {
      type: Function,
    },
  },
  watch: {
    C_value: {
      handler() {
        this.$emit("input", this.C_value);
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>